import React from 'react';
import { Shield, Code, Sparkles, ChevronDown } from 'lucide-react';
import { Button } from './ui/button';
import './Hero.css';

const Hero = () => {
  const scrollToProjects = () => {
    const element = document.getElementById('filmography');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const techKeywords = [
    'JAVA', 'PYTHON', 'PHP', 'REACT', 'NODE.JS', 'MONGODB', 'MYSQL', 
    'CYBERSÉCURITÉ', 'POO', 'MVC', 'ALGORITHMES', 'GRAPHES'
  ];
  

  return (
    <section id="hero" className="hero">
      {/* Animated tech keywords marquee */}
      <div className="tech-marquee">
        <div className="marquee-content">
          {[...techKeywords, ...techKeywords].map((keyword, index) => (
            <span key={index} className="marquee-item">{keyword}</span>
          ))}
        </div>
      </div>

      <div className="hero-background">
        <div className="tech-grid"></div>
        <div className="particles-container">
          {[...Array(30)].map((_, i) => (
            <div 
              key={i} 
              className="particle"
              style={{
                left: `${Math.random() * 100}%`,
                animationDelay: `${Math.random() * 5}s`,
                animationDuration: `${3 + Math.random() * 4}s`
              }}
            />
          ))}
        </div>
      </div>
      
      <div className="hero-content">
        <div className="hero-badge">
          <Shield size={16} />
          <span>INFORMATIQUE & DÉVELOPPEMENT</span>
        </div>
        
        <div className="hero-title-wrapper">
          <h1 className="hero-title">
            <span className="title-greeting">Bonjour, je suis</span>
            <span className="title-name">
              <span className="name-first">OMAR</span>
              <span className="name-last">ALDROUBI</span>
            </span>
            <span className="title-role">
              <Code className="role-icon" />
              Étudiant en Licence Informatique
            </span>
          </h1>
        </div>
        
        <p className="hero-description">
          Étudiant en informatique à l'Université de Caen, passionné par la<strong> création de projets concrets</strong>, <strong>cybersécurité</strong>, le <strong>développement logiciel</strong> et l'<strong>innovation technologique</strong>.
          J'aime apprendre, expérimenter et améliorer continuellement ma façon de coder.
        </p>
        
        <div className="hero-stats">
          <div className="stat-item">
            <div className="stat-number" data-target="7">0</div>
            <div className="stat-label">Projets</div>
          </div>
          <div className="stat-divider"></div>
          <div className="stat-item">
            <div className="stat-number" data-target="10">0</div>
            <div className="stat-label">Technologies</div>
          </div>
          <div className="stat-divider"></div>
          <div className="stat-item">
            <div className="stat-number">Licence Informatique</div>
            <div className="stat-label">En cours</div>
          </div>
        </div>
        
        <div className="hero-actions">
          <Button 
            onClick={scrollToProjects}
            className="hero-btn-primary"
            size="lg"
          >
            <Sparkles size={18} />
            Découvrir Mes Projets
          </Button>
          <Button 
            onClick={() => document.getElementById('contact').scrollIntoView({ behavior: 'smooth' })}
            className="hero-btn-secondary"
            size="lg"
            variant="outline"
          >
            Me Contacter
          </Button>
        </div>
      </div> {/* <-- FIN DE LA BOÎTE HERO-CONTENT */}
      
   
    </section>
  );
};

export default Hero;